"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _play = _interopRequireDefault(require("cccisd-icons/svg/play"));
var _cccisdRenderInBody = _interopRequireDefault(require("cccisd-render-in-body"));
var _ensureGlobalClick = _interopRequireDefault(require("./ensureGlobalClick.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = function _default() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$hidePlayButton = _ref.hidePlayButton,
    hidePlayButton = _ref$hidePlayButton === void 0 ? false : _ref$hidePlayButton,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Click anywhere to start' : _ref$title;
  return function (WrappedComponent) {
    var Wrapper = function Wrapper(props) {
      if (!props.globalClickCaptured) {
        var shouldHide = typeof hidePlayButton === 'function' ? hidePlayButton(props) : hidePlayButton;
        if (!shouldHide) {
          return /*#__PURE__*/_react["default"].createElement(_cccisdRenderInBody["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
            className: _ensureGlobalClick["default"].bigPlayButton
          }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_play["default"], null), /*#__PURE__*/_react["default"].createElement("div", {
            className: _ensureGlobalClick["default"].title
          }, title))));
        }
      }
      return /*#__PURE__*/_react["default"].createElement(WrappedComponent, props);
    };
    var mapStateToProps = function mapStateToProps(state) {
      return {
        globalClickCaptured: state.boilerplate.globalClickCaptured
      };
    };
    return (0, _reactRedux.connect)(mapStateToProps)(Wrapper);
  };
};
exports["default"] = _default;